import { createSelector } from '@reduxjs/toolkit'
import { FormRootState } from './formStore'

// select up major errors encountered in putting the form together that can't
// be displayed as errors in the place of affected form controls.
// for example, a directory feed with the wrong column order might break the
// whole form, so this should be flagged above everything.  whereas a
// missing directory item is easy to note in place of the form controls
// that reference the missing directory item.
// TODO should probably add some additional integrity checks on data inbound
// from the server and flag missing entities, etc, although perhaps those will
// mostly just be control-level errors also
export const selectMajorRenderErrors = createSelector(
// 	(state: FormRootState) => state.directory.itemError,
// 	(state: FormRootState) => state.directory.valuelistError,
	(state: FormRootState) => state.render.showDebugInfo ? state.form.calculationErrors : [],
	(calcErrors) => ([
		// ...itemError.map(e => '[DirectoryItem] ' + e),
		// ...valuelistError.map(e => '[Valuelist] ' + e),
		...calcErrors.map(e => '[Calculation] ' + e)
	])
)
